//@flow
import React, { useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import RecommendedCarousel from 'components/organisms/recommendedCarousel';
import RecommendedMobileCarousel from 'components/organisms/recommendedMobileCarousel';
import type { RecommendedScreenType } from 'types/common';
import { uniqBy } from 'lodash';
import { LocationDropdown } from 'components/molecules/locationDropdown';
import type { DropdownOption } from 'components/molecules/formDropdown';
import { withRouter } from 'react-router-dom';
import { useViewport } from 'components/templates/viewportProvider';
import { RouteUtil } from 'utils/RouteUtil';
import './styles.scss';

type Props = {
  data: Array<RecommendedScreenType>,
};

const SisterRestaurants = (props: Props) => {
  const [cityId, setCityId] = useState(null);
  const { data, breadcrumbList } = props;
  const { height } = useViewport();

  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-device-width: 1224px)',
  });
  const isBigScreen = useMediaQuery({ query: '(min-device-width: 1824px)' });
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
  const isTabletOrMobileDevice = useMediaQuery({
    query: '(max-device-width: 1224px)',
  });
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });

  // Locations filter
  const locations = getRestaurantLocations(data.data);
  const onLocationSelect = location => {
    setCityId(location.value);
  };
  const filteredRestaurants = getFilteredRestaurants(data.data, cityId);

  const goToRestaurantDetails = data => {
    const urlSlug = data.urlSlug;
    const outletSlug = data.outletUrlSlug;
    const locationPath = props.location;
    if (data.exploreLink) {
      window.open(data.exploreLink);
    } else {
      RouteUtil.setRouteChange(
        props,
        `/restaurants/${urlSlug}/${outletSlug}`,
        locationPath.hash,
        locationPath.pathname
      );
      window.location.reload();
    }
  };

  const locationsComponent = () => {
    return (
      <LocationDropdown
        locations={locations}
        onSelect={onLocationSelect}
        mode={'light'}
        value={cityId}
        placeholder={'LOCATIONS'}
        className={'section-header-filter'}
      />
    );
  };

  return (
    <div style={{ height }} id={'sister-restaurants'}>
      {(isDesktopOrLaptop || isBigScreen || isPortrait === false) && (
        <>
          <RecommendedCarousel
            recommendedList={filteredRestaurants}
            fetchTitle={
              <h2>
                Try Our Sister <br />
                Restaurants
              </h2>
            }
            displayOptions={true}
            isRestaurant={true}
            isDefinedRoute={true}
            optionsComponent={locationsComponent()}
            onClick={data => goToRestaurantDetails(data)}
            breadcrumbList={breadcrumbList}
          />
        </>
      )}

      {(isTabletOrMobileDevice || isTabletOrMobile) && isPortrait === true && (
        <RecommendedMobileCarousel
          recommendedList={data.data}
          fetchTitle={
            <h3 className={'restaurant-recommended-section'}>
              Explore Our <br />
              Restaurants Network
            </h3>
          }
          isDisplayLocationIcon={false}
          isDefinedRoute={true}
          onClick={data => goToRestaurantDetails(data)}
          breadcrumbList={breadcrumbList}
        />
      )}
    </div>
  );
};

export default withRouter(SisterRestaurants);

// Locations filter helpers
const getRestaurantLocations = (
  restaurants: Array<RecommendedScreenType>
): Array<DropdownOption> => {
  if (!restaurants || restaurants.length === 0) {
    return [];
  }

  const cities = restaurants.map(restaurant => {
    return {
      value: restaurant.cityId,
      label: restaurant.cityName,
    };
  });
  cities.unshift({ value: null, label: 'Locations' });

  return uniqBy(cities, 'value');
};

const getFilteredRestaurants = (
  restaurants: Array<RecommendedScreenType>,
  cityId: number | string
): Array<RecommendedScreenType> => {
  if (!cityId) {
    return restaurants;
  }

  return restaurants.filter(restaurant => restaurant.cityId === cityId);
};
